import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "Index" */ '../views/index/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/login/register.vue')
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: () => import(/* webpackChunkName: "protocol" */ '../views/login/protocol.vue')
  },
  {
    path: '/forgetpwd',
    name: 'forgetpwd',
    component: () => import(/* webpackChunkName: "forgetpwd" */ '../views/login/forgetpwd.vue')
  },
  {
    path: '/serve',
    name: 'serve',
    component: () => import(/* webpackChunkName: "serve" */ '../views/serve/index.vue')
  },
  {
    path: '/serveDetail',
    name: 'serveDetail',
    component: () => import(/* webpackChunkName: "serveDetail" */ '../views/serve/serveDetail.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "test" */ '../views/test/index.vue')
  },
  {
    path: '/intermediary',
    name: 'intermediary',
    component: () => import(/* webpackChunkName: "intermediary" */ '../views/intermediary/index.vue')
  },
  {
    path: '/intermeReg',
    name: 'intermeReg',
    component: () => import(/* webpackChunkName: "intermeReg" */ '../views/intermediary/intermeReg.vue')
  },
  {
    path: '/purchase',
    name: 'purchase',
    component: () => import(/* webpackChunkName: "purchase" */ '../views/purchase/index.vue')
  },
  {
    path: '/purchaseDetail/:id',
    name: 'purchaseDetail',
    component: () => import(/* webpackChunkName: "purchaseDetail" */ '../views/purchase/purchaseDetail.vue')
  },
  {
    path: '/select',
    name: 'select',
    component: () => import(/* webpackChunkName: "select" */ '../views/select/index.vue')
  },
  {
    path: '/selectDetail',
    name: 'selectDetail',
    component: () => import(/* webpackChunkName: "selectDetail" */ '../views/select/selectDetail.vue')
  },
  {
    path: '/inform',
    name: 'inform',
    component: () => import(/* webpackChunkName: "inform" */ '../views/inform/index.vue')
  },
  {
    path: '/informDetail',
    name: 'informDetail',
    component: () => import(/* webpackChunkName: "informDetail" */ '../views/inform/informDetail.vue')
  },
  {
    path: '/contract',
    name: 'contract',
    component: () => import(/* webpackChunkName: "contract" */ '../views/contract/index.vue')
  },
  {
    path: '/credit',
    name: 'credit',
    component: () => import(/* webpackChunkName: "credit" */ '../views/credit/index.vue')
  },
  {
    path: '/fileDetail',
    name: 'fileDetail',
    component: () => import(/* webpackChunkName: "fileDetail" */ '../views/credit/fileDetail.vue')
  },
  {
    path: '/creditDetail',
    name: 'creditDetail',
    component: () => import(/* webpackChunkName: "creditDetail" */ '../views/credit/creditDetail.vue'),
    redirect:'/creditDetail/allServe',
    children:[
      {
        path:"allServe",
        name:"allServe",
        component: () => import(/* webpackChunkName: "allServe" */ '../views/credit/creditDetailChildRoute/allServe.vue'),
      },
      {
        path:"beChosenRecord",
        name:"beChosenRecord",
        component: () => import(/* webpackChunkName: "beChosenRecord" */ '../views/credit/creditDetailChildRoute/beChosenRecord.vue'),
      },
      {
        path:"creditInfo",
        name:"creditInfo",
        component: () => import(/* webpackChunkName: "creditInfo" */ '../views/credit/creditDetailChildRoute/creditInfo.vue'),
      },
      {
        path:"qualificationInfo",
        name:"qualificationInfo",
        component: () => import(/* webpackChunkName: "qualificationInfo" */ '../views/credit/creditDetailChildRoute/qualificationInfo.vue'),
      },
      {
        path:"serveInfo",
        name:"serveInfo",
        component: () => import(/* webpackChunkName: "serveInfo" */ '../views/credit/creditDetailChildRoute/serveInfo.vue'),
      },
      {
        path:"userInfo",
        name:"userInfo",
        component: () => import(/* webpackChunkName: "userInfo" */ '../views/credit/creditDetailChildRoute/userInfo.vue'),
      },
    ]
  },
  {
    path: '/serveZixun',
    name: 'serveZixun',
    component: () => import(/* webpackChunkName: "serveZixun" */ '../views/serveZixun/index.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import(/* webpackChunkName: "policy" */ '../views/policy/index.vue')
  },
  {
    path: '/bidding',
    name: 'bidding',
    component: () => import(/* webpackChunkName: "bidding" */ '../views/bidding/index.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
